//
//
//
//
//
//
//
//
//
//
//
//
//

import TextWithIcon from '../other/TextWithIcon'
export default {
  components: {
    TextWithIcon
  },
  data() {
    return {
      localization: {
        ru: {
          text: 'к сожалению, пока нет шедевров, подходящих вашим требованиям. Попробуйте сформулировать запрос иначе.',
          mir: 'Патронат над произведением из коллекции платёжной системы «Мир» невозможно купить, зато его можно выиграть! Для этого участвуйте в проекте с картой «Мир». Как только сумма ваших покупок составит 30 000 рублей в месяц, у вас появится возможность поучаствовать в розыгрыше и стать патроном произведения из данной коллекции.',
        },
        en: {
          text: 'en к сожалению, пока нет шедевров, подходящих вашим требованиям. Попробуйте сформулировать запрос иначе.',
          mir: 'en Патронат над произведением из коллекции платёжной системы «Мир» невозможно купить, зато его можно выиграть! Для этого участвуйте в проекте с картой «Мир». Как только сумма ваших покупок составит 30 000 рублей в месяц, у вас появится возможность поучаствовать в розыгрыше и стать патроном произведения из данной коллекции.',
        }
      }
    }
  },
  computed: {
    defineText() {
      const { loyalty, canPatron } = this.$route.query
      if (loyalty === '1' && canPatron === 'true'){
        return this.$t('masterPieceNotFound.mirText')
      }
      return this.$t('masterPieceNotFound.text')
    }
  },
  mounted() {
    this.$emit('loaded')
  }
}
